import ClaudeService from "./claudeService";
import { surfaceItemsByRoom } from "../lib/worldJson";

const SYSTEM_PROMPT =
  "You write a one-to-two sentence, factual, glanceable recap of what the user was working on " +
  "in this room, plus one suggested next step. No personality, no fluff, no greeting. " +
  'Output strict JSON only: {"summary": string, "next_step": string}. ' +
  "Keep summary under 25 words and next_step under 15 words.";

/**
 * Generates a short factual summary and next step for a room based on its surface items.
 * Returns { summary, next_step } or null if there is nothing to summarize or on any error.
 *
 * @param {string} roomId
 * @param {Array}  allSurfaceItems  - flat array of surface items from world_json (persisted)
 */
export async function summarizeRoom(roomId, allSurfaceItems) {
  try {
    const byRoom = surfaceItemsByRoom(allSurfaceItems);
    const items  = byRoom[roomId] || [];
    if (items.length === 0) return null;

    // Sort by timestamp desc so the most recent work appears first
    const sorted = [...items].sort((a, b) => (b.timestamp || b.savedAt || 0) - (a.timestamp || a.savedAt || 0));

    const lines = sorted.map(item => {
      const parts = [];
      if (item.surface)  parts.push(`[${item.surface}]`);
      if (item.title)    parts.push(item.title);
      if (item.content)  parts.push(item.content.slice(0, 300));   // cap per item
      if (item.type)     parts.push(`(type: ${item.type})`);
      if (item.done)     parts.push("(done)");
      return parts.join(" — ");
    });

    const userMessage = `Room items:\n${lines.join("\n")}`;

    const result = await ClaudeService.sendStructuredMessage({
      system:    SYSTEM_PROMPT,
      messages:  [{ role: "user", content: userMessage }],
      maxTokens: 256,
    });

    if (!result.success || !result.data?.summary) return null;

    return {
      summary:   result.data.summary,
      next_step: result.data.next_step || null,
    };
  } catch {
    return null;
  }
}
